// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__tR-_H","productName":"Table_productName__Fy4rJ"};